export default "__VITE_ASSET__CbLjn$Ce__"